import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { BannerInfoQuery, BannerInfoQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(BannerInfoQuery)
@Wrapper(BannerInfoQueryHandlerBase)
export class BannerInfoQueryHandler {
    public constructor(
        http: Http
    ) { }
}